import { useEffect, useMemo, useState } from 'react';
import './App.css';
import { Navbar } from './components/Navbar';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { UploadsPage } from './pages/UploadsPage';
import { getRecentUploadCode } from './services/uploadService';

const routes = {
  upload: 'upload',
  privacy: 'privacy',
};

export const App = () => {
  const [route, setRoute] = useState(routes.upload);
  const [lastCode, setLastCode] = useState(null);

  useEffect(() => {
    setLastCode(getRecentUploadCode());
  }, []);

  const page = useMemo(() => {
    if (route === routes.privacy) {
      return <PrivacyPolicyPage />;
    }

    return <UploadsPage onLastCodeChange={setLastCode} />;
  }, [route]);

  return (
    <>
      <div className="view-container">
        <Navbar activeRoute={route} lastCode={lastCode} onNavigate={setRoute} />
        <main>{page}</main>
      </div>
      <footer className="py-3 text-center">
        <p className="m-0">Copyright Ciancio 1913 (c) {new Date().getFullYear()}</p>
      </footer>
    </>
  );
}

